/* istanbul ignore file */
export enum ROLES {
  ADMIN = 'admin'
}

export enum PERMISSIONS {
  // Roles
  MANAGE_ROLES = 'manage roles',
  VIEW_ROLES = 'view roles',

  // Swile Credit
  CREATE_SWILE_CREDIT = 'create swile-credit',
  MANAGE_SWILE_CREDIT = 'manage swile-credit',

  // Employees
  MANAGE_EMPLOYEES = 'manage employees',
  VIEW_EMPLOYEES = 'view employees',

  // User Activities
  VIEW_USER_ACTIVITIES = 'view users-activities',

  // Corporate
  MANAGE_CORPORATE = 'manage corporate',
  VIEW_CORPORATE = 'view corporate',

  // Users
  MANAGE_USERS = 'manage users',
  VIEW_USERS = 'view users',

  // Orders
  MANAGE_ORDERS = 'manage orders',
  VIEW_ORDERS = 'view orders',

  // Cards
  MANAGE_CARDS = 'manage cards',
  VIEW_CARDS = 'view cards',

  // Branches
  MANAGE_BRANCHES = 'manage branchs',
  VIEW_BRANCHES = 'view branchs',

  // Jobs
  VIEW_JOBS = 'view jobs',

  // Workgroups
  MANAGE_WORKGROUPS = 'manage workgroups',
  VIEW_WORKGROUPS = 'view workgroups',

  // Swile +
  MANAGE_SWILE_MAIS = 'manage swile-mais',
  VIEW_SWILE_MAIS = 'view swile-mais'
}

export enum ORDER_STATUS {
  CANCELED = 'CANCELED',
  APPROVED = 'APPROVED',
  PAID = 'PAID'
}
